<template>
  <div class="mainWrapper">
    <div class="sourceMain">
      <b-row class="sourceMainSections">
        <b-col sm="2" class="sectionsFilters">
          <b-col class="filters">
            <p>Filtros</p>
          </b-col>
          <b-col class="section1">
            <b-row>
              <b-col sm="12">
                <span class="filtersTitle">Fonte</span>
              </b-col>
              <b-col>
                <b-form-input v-model="filterSourceName"></b-form-input>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12">
                <span class="filtersTitle">Tipo</span>
              </b-col>
              <b-col>
                <v-select
                  v-model="selectedSource"
                  :options="optionsOfTypeSource"
                  class="filtersSelect"
                  label="type"
                  :reduce="(type) => type.code"
                  ><span slot="no-options"
                    >Não foram obtidos resultados</span
                  ></v-select
                >
              </b-col>
              <!-- <b-form-select v-model="selectedSource" :options="optionsForSource"></b-form-select> -->
            </b-row>
            <b-col class="checkBox">
              <b-form-checkbox
                class="filtersCheckBox"
                v-model="automaticPublish"
                value="2"
                unchecked-value="-1"
                >Publicaçao Automática</b-form-checkbox
              >
            </b-col>
            <b-col class="checkBox">
              <b-form-checkbox
                class="filtersCheckBox"
                v-model="automaticImport"
                value="1"
                unchecked-value="-1"
                >Importaçao Automática</b-form-checkbox
              >
            </b-col>
            <b-col class="filterButton">
              <b-button class="btnFilter" @click="filterSources()"
                >Pesquisar</b-button
              >
            </b-col>
          </b-col>
        </b-col>
        <b-col sm="4" class="section1Sources">
          <b-col class="section1Title">
            <b-row>
              <b-col style="text-align: left">Fontes</b-col>
              <b-col class="createDiv">
                <b-button
                  class="createBtn"
                  @click="
                    isCreateSource = true;
                    section3 = false;
                  "
                  >Criar Fonte</b-button
                >
              </b-col>
            </b-row>
          </b-col>
          <b-col class="section2">
            <b-col
              class="section2Source"
              v-for="(source, index) in filteredSources"
              :key="source.c_id"
              @click="openSection3(source.c_id)"
            >
              <b-row class="section2Reference">
                <b-col sm="10">
                  <h6>{{ source.c_u_ReferenceSource }}</h6>
                </b-col>
                <b-col class="icons" sm="2">
                  <fa
                    v-if="source.c_u_Status == -1"
                    :icon="['fas', 'times-circle']"
                    size="lg"
                    style="color: red"
                    title="Inativo"
                  />
                  <fa
                    v-if="source.c_u_Status == 1"
                    :icon="['fas', 'check-circle']"
                    size="lg"
                    style="color: green"
                    title="Ativo"
                  />
                  <fa
                    v-if="source.c_u_Status == 1 && source.c_u_PublishType == 2"
                    :icon="['fab', 'adn']"
                    style="color: rgb(24, 65, 77); margin-left: 4px"
                    size="lg"
                    title="Publicação automática"
                  />
                  <fa
                    v-if="source.c_u_Status == 2"
                    :icon="['fas', 'check-circle']"
                    size="lg"
                    style="color: lightblue"
                    title="Básico"
                  />
                </b-col>
              </b-row>
            </b-col>
          </b-col>
        </b-col>
        <b-col sm="6">
          <b-col v-if="isCreateSource">
            <b-col class="section3Reference">
              <p>Criaçao de Fonte</p>
            </b-col>
            <b-col>
              <b-col class="section3Title">
                <h4>Fonte</h4>
              </b-col>
              <b-col>
                <b-row class="my-1">
                  <b-col sm="2" class="labelSource">
                    <label>Nome</label>
                  </b-col>
                  <b-col sm="10" class="referenceName">
                    <v-select
                      v-model="selectedSourceView"
                      :options="sourcesView"
                      label="source"
                      style="background-color: white"
                      ><span slot="no-options"
                        >Não foram obtidos resultados</span
                      ></v-select
                    >
                  </b-col>
                </b-row>
              </b-col>
              <b-col>
                <b-row class="my-1">
                  <b-col sm="2" class="labelSource">
                    <label>Tipo</label>
                  </b-col>
                  <b-col sm="10" class="referenceName">
                    <b-form-select
                      :options="typeOptions"
                      v-model="sourceObject.c_u_Type"
                      @change="
                        sourceObject.c_u_Type == 3
                          ? (isNotSearchEngine = false)
                          : (isNotSearchEngine = true);
                        $forceUpdate();
                      "
                    ></b-form-select>
                  </b-col>
                </b-row>
              </b-col>
              <b-col>
                <b-row class="my-1">
                  <b-col sm="2" class="labelSource" style="padding: 0px 5px">
                    <label>Regularidade</label>
                  </b-col>
                  <b-col sm="10" class="referenceName">
                    <b-form-select
                      :options="regularityOptions"
                      v-model="sourceObject.c_u_Regularity"
                    ></b-form-select>
                  </b-col>
                </b-row>
              </b-col>
              <b-col class="d-none">
                <b-row class="my-1">
                  <b-col sm="2" class="labelSource">
                    <label>Keywords</label>
                  </b-col>
                  <b-col sm="10" class="referenceName">
                    <b-form-input
                      size="sm"
                      v-model="sourceObject.c_u_Keywords"
                      v-on:keyup="semicolonKey"
                    ></b-form-input>
                  </b-col>
                </b-row>
              </b-col>
              <b-col>
                <b-row class="my-1">
                  <b-col sm="2" class="labelSource">
                    <label>Estado</label>
                  </b-col>
                  <b-col sm="10" class="referenceName">
                    <b-form-radio-group>
                      <b-form-radio
                        v-model="sourceObject.c_u_Status"
                        id="sourceStatus_1"
                        name="sourceStatus"
                        value="-1"
                        >Inativo</b-form-radio
                      >
                      <b-form-radio
                        v-model="sourceObject.c_u_Status"
                        id="sourceStatus_2"
                        name="sourceStatus"
                        value="1"
                        >Ativo</b-form-radio
                      >
                      <b-form-radio
                        v-model="sourceObject.c_u_Status"
                        id="sourceStatus_3"
                        name="sourceStatus"
                        value="2"
                        >Básico</b-form-radio
                      >
                    </b-form-radio-group>
                  </b-col>
                </b-row>
              </b-col>
            </b-col>
            <b-col>
              <b-col class="section3Title">
                <h4>Importação das Noticias</h4>
              </b-col>
              <b-col>
                <b-row class="my-1">
                  <b-col sm="2" class="labelSource" style="padding: 0px 5px">
                    <label>Configuração</label>
                  </b-col>
                  <b-col sm="10" class="referenceName">
                    <v-select
                      v-model="sourceObject.c_u_PublishType"
                      :options="optionsPublishType"
                      label="type"
                      :reduce="(type) => type.code"
                      style="background-color: white"
                      ><span slot="no-options"
                        >Não foram obtidos resultados</span
                      ></v-select
                    >
                  </b-col>
                </b-row>
              </b-col>
            </b-col>
            <b-row>
              <b-col class="createXML">
                <b-button size="sm" v-b-modal.createConfigs1Xml
                  >Configuração XML 1</b-button
                >
              </b-col>
              <b-col class="createXML">
                <b-button size="sm" v-b-modal.createXml2
                  >Configuração XML 2</b-button
                >
              </b-col>
            </b-row>
            <b-col class="section3Footer">
              <b-button @click="createSource()">Criar</b-button>
            </b-col>
          </b-col>
          <!-- Edition of Source -->
          <b-col v-if="section3">
            <b-col class="section3Reference">
              <p>{{ clickedSource.c_u_ReferenceSource }}</p>
            </b-col>
            <b-col>
              <b-col class="section3Title">
                <h4>Fonte</h4>
              </b-col>
              <b-col>
                <b-row class="my-1">
                  <b-col sm="2" class="labelSource">
                    <label>Nome</label>
                  </b-col>
                  <b-col sm="10" class="referenceName">{{
                    clickedSource.c_u_ReferenceSource
                  }}</b-col>
                </b-row>
              </b-col>
              <b-col>
                <b-row class="my-1">
                  <b-col sm="2" class="labelSource">
                    <label>Tipo</label>
                  </b-col>
                  <b-col sm="10" class="referenceName">
                    <b-form-select
                      :options="typeOptions"
                      v-model="clickedSource.c_u_Type"
                      @change="
                        clickedSource.c_u_Type == 3
                          ? (isNotSearchEngine = false)
                          : (isNotSearchEngine = true);
                        $forceUpdate();
                      "
                    ></b-form-select>
                  </b-col>
                </b-row>
              </b-col>
              <b-col>
                <b-row class="my-1">
                  <b-col sm="2" class="labelSource" style="padding: 0px 5px">
                    <label>Regularidade</label>
                  </b-col>
                  <b-col sm="10" class="referenceName">
                    <b-form-select
                      :options="regularityOptions"
                      v-model="clickedSource.c_u_Regularity"
                    ></b-form-select>
                  </b-col>
                </b-row>
              </b-col>
              <b-col>
                <b-row class="my-1">
                  <b-col sm="2" class="labelSource d-none">
                    <label>Keywords</label>
                  </b-col>
                  <b-col sm="10" class="referenceName d-none">
                    <b-form-input
                      size="sm"
                      placeholder="Enter the Keywords"
                      v-model="clickedSource.c_u_Keywords"
                      v-on:keyup="semicolonKey"
                    ></b-form-input>
                  </b-col>
                  <b-col>
                    <b-row class="my-1">
                      <b-col sm="2" class="labelSource">
                        <label>Estado</label>
                      </b-col>
                      <b-col sm="10" class="referenceName">
                        <b-form-radio-group>
                          <b-form-radio
                            v-model="clickedSource.c_u_Status"
                            id="sourceStatus_1"
                            name="sourceStatus"
                            value="-1"
                            >Inativo</b-form-radio
                          >
                          <b-form-radio
                            v-model="clickedSource.c_u_Status"
                            id="sourceStatus_2"
                            name="sourceStatus"
                            value="1"
                            >Ativo</b-form-radio
                          >
                          <b-form-radio
                            v-model="clickedSource.c_u_Status"
                            id="sourceStatus_3"
                            name="sourceStatus"
                            value="2"
                            >Básico</b-form-radio
                          >
                        </b-form-radio-group>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-col>
            </b-col>
            <b-col>
              <b-col class="section3Title">
                <h4>Importação das Noticias</h4>
              </b-col>
              <b-col>
                <b-row class="my-1">
                  <b-col sm="2" class="labelSource" style="padding: 0px 5px">
                    <label>Configuração</label>
                  </b-col>
                  <b-col sm="10" class="referenceName">
                    <v-select
                      v-model="clickedSource.c_u_PublishType"
                      :options="optionsPublishType"
                      label="type"
                      :reduce="(type) => type.code"
                      style="background-color: white"
                      ><span slot="no-options"
                        >Não foram obtidos resultados</span
                      ></v-select
                    >
                  </b-col>
                </b-row>
              </b-col>
              <b-col style="display:none;">
                <b-row class="my-1">
                  <b-col sm="2" class="labelSource">
                    <label>Horas</label>
                  </b-col>
                  <b-col sm="10" class="referenceName">
                    <b-row>
                      <b-col sm="5">
                        <b-form-datepicker
                          placeholder="Data de inicio"
                          v-model="startDate"
                          class="mb-2"
                        ></b-form-datepicker>
                        <b-form-timepicker
                          size="sm"
                          local="en"
                          v-model="startHour"
                          placeholder="Hora de inicio"
                          class="mb-2"
                        ></b-form-timepicker>
                      </b-col>
                      <b-col sm="5">
                        <b-form-datepicker
                          placeholder="Data de Fim"
                          v-model="endDate"
                          class="mb-2"
                        ></b-form-datepicker>
                        <b-form-timepicker
                          size="sm"
                          local="en"
                          v-model="endHour"
                          placeholder="Hora de fim"
                          class="mb-2"
                        ></b-form-timepicker>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-col>
            </b-col>
            <b-row>
              <b-col class="editXML">
                <b-button
                  size="sm"
                  @click="editUrl(clickedSource)"
                  v-b-modal.editUrlSource
                  >Configuração XML 1</b-button
                >
              </b-col>
              <b-col class="editXML">
                <b-button
                  size="sm"
                  @click="editUrl(clickedSource)"
                  v-b-modal.editSource2
                  >Configuração XML 2</b-button
                >
              </b-col>
            </b-row>
            <b-col class="section3Footer">
              <b-button
                style="background-color: rgb(162, 91, 113)"
                @click="deleteUrl(clickedSource)"
                v-b-modal.deleteUrlSource
                >Apagar</b-button
              >
              <b-button @click="editedSource()">Guardar</b-button>
            </b-col>
          </b-col>
        </b-col>
        <!-- <b-col sm="10">
          <b-table
            striped
            hover
            :items="filteredSources"
            :per-page="5"
            :current-page="currentPage"
            :fields="fields"
            small
            fixed
            caption-top
          >
            <template v-slot:cell(actions)="data">
              <b-button
                variant="primary"
                size="sm"
                v-if="data.item.c_u_Type == 1"
                @click="editUrl(data.item)"
                v-b-modal.editUrlSource
              >
                <fa icon="edit" size="sm" />Edit
              </b-button>
              <b-button
                variant="primary"
                size="sm"
                v-if="data.item.c_u_Type == 2"
                @click="editUrl(data.item)"
                v-b-modal.editUrlSource
              >
                <fa icon="edit" size="sm" />Edit
              </b-button>
              <b-button
                variant="danger"
                size="sm"
                @click="deleteUrl(data.item)"
                v-b-modal.deleteUrlSource
              >
                <fa icon="trash" size="sm" />
              </b-button>
            </template>
            <template v-slot:table-caption>
              <b-dropdown
                id="dropdown-left"
                text="Create New"
                variant="outline-primary"
                class="m-2"
              >
                <b-dropdown-item v-b-modal.createUrl>URL</b-dropdown-item>
                <b-dropdown-item v-b-modal.createUrl>RSS</b-dropdown-item>
                <b-dropdown-item href="#">Search Engine</b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
          <div class="mt-3">
            <b-pagination
              :total-rows="totalItems"
              :per-page="5"
              align="center"
              v-model="currentPage"
            ></b-pagination>
          </div>
        </b-col>-->
      </b-row>
    </div>
    <!-- modal for the CRUD -->
    <createUrl
      v-bind:isNotSearchEngine="isNotSearchEngine"
      v-bind:sourceObject="sourceObject"
      @ok="createXmls"
    ></createUrl>
    <!-- <createRss @ok="getSources();$forceUpdate()"></createRss> -->
    <deleteUrl :sourceUrl="sourceUrl" @ok="deletedSource"></deleteUrl>
    <editUrl :idSource="idSource" @ok="updateParamters"></editUrl>
  </div>
</template>

<script>
import createUrl from "../Sources/CreateUrl";
import createRss from "../Sources/rss/CreateRss";
import deleteUrl from "../Sources/DeleteUrl";
import editUrl from "../Sources/EditUrl";
import vSelect from "vue-select";
import Vue from "vue";
import "vue-select/dist/vue-select.css";
import { mapGetters } from "vuex";
import $ from "jquery";

export default {
  name: "SourceMain",

  data() {
    return {
      sources: [],
      filteredSources: [],
      sourceObject: {
        c_id: 0,
        c_u_Type: 0,
        c_u_Status: 1,
        c_u_PublishType: 0,
        c_u_Regularity: 0,
        c_u_ReferenceSource: "",
        c_u_Keywords: "",
        c_u_Parameters1: "",
        c_u_Parameters2: "",
      },
      endpoint: "Sources",
      endpointTime: "TimeSchedules",
      isCreateSource: false,
      sourceUrl: null,
      timeSchedule: {
        c_u_TimeStart: "",
        c_u_TimeEnd: "",
        c_u_Status: 2,
        c_r_Source: 0,
      },
      section3: false,
      isNotSearchEngine: true,
      idSource: null,
      automaticPublish: 0,
      automaticImport: 0,
      clickedSource: [],
      filterSourceName: "",
      selectedSource: [],
      sourcesView: [],
      selectedSourceView: [],
      startDate: "",
      endDate: "",
      startHour: "",
      endHour: "",
      optionsOfTypeSource: [
        { type: "URL", code: 1 },
        { type: "RSS", code: 2 },
        { type: "Search Engine", code: 3 },
      ],
      optionsPublishType: [
        { code: 0, type: "Publicação Manual" },
        { code: 1, type: "Descarregamento Automático" },
        { code: 2, type: "Publicação Automática" },
      ],
      optionsForSource: [
        { value: 1, text: "URL" },
        { value: 2, text: "RSS" },
        { value: 3, text: "Search Engine" },
      ],
      typeOptions: [
        { value: "0", text: "Selecione uma das opções" },
        { value: 1, text: "URL" },
        { value: 2, text: "RSS Feed" },
        { value: 3, text: "Search Engine" },
      ],
      regularityOptions: [
        { value: "0", text: "Selecione uma das opções" },
        { value: "10", text: "10 Minutos" },
        { value: "20", text: "20 Minutos" },
        { value: "30", text: "30 Minutos" },
        { value: "40", text: "40 Minutos" },
        { value: "50", text: "50 Minutos" },
        { value: "60", text: "60 Minutos" },
        { value: "720", text: "12 Horas" }
      ],
    };
  },
  computed: {
    ...mapGetters({
      isSaved: "api/isSaved",
    }),
  },
  watch: {
    filterSourceName(to, from) {
      this.filterSources();
    },
    async selectedSource(to, from) {
      this.filterSources();
    },

    async automaticPublish(to, form) {
      this.filterSources();
    },

    async automaticImport(to, from) {
      this.filterSources();
    },
  },
  components: {
    createUrl,
    createRss,
    deleteUrl,
    editUrl,
    vSelect,
  },
  methods: {
    async getSources() {
      this.$api.data.endpoint = this.endpoint;
      this.sources = await this.$api.data.find();
      this.totalItems = this.sources.length;
      //receive the sources by the principal table using views
      for (let index = 0; index < this.sources.length; index++) {
        Vue.set(this.filteredSources, index, this.sources[index]);
      }
      this.$api.data.endpoint = "Vsources/SourcesNotImported";
      let viewSources = await this.$api.data.find();
      for (let index = 0; index < viewSources.length; index++) {
        Vue.set(this.sourcesView, index, {
          id: viewSources[index].id,
          source: viewSources[index].sourceName,
        });
      }
      this.$forceUpdate();
    },

    async filterSources() {
      //console.log(this.filterSourceName);
      //console.log(this.selectedSource);
      //console.log(this.automaticPublish);
      //console.log(this.automaticImport);
      //console.log("this.sources", this.sources);

      let filteringSources = _.filter(this.sources, (src) => {
        return true;
      });

      if (this.filterSourceName.trim().length > 0) {
        filteringSources = _.filter(filteringSources, (src) => {
          return (
            src.c_u_ReferenceSource
              .toLowerCase()
              .indexOf(this.filterSourceName.toLowerCase()) > -1
          );
        });
      }
      if (this.selectedSource != null) {
        try {
          var SourceType = parseInt(this.selectedSource, 10);
          if (!isNaN(SourceType)) {
            filteringSources = _.filter(filteringSources, (src) => {
              return src.c_u_Type == SourceType;
            });
          }
        } catch (err) {}
      }
      if (this.automaticPublish == 2) {
        filteringSources = _.filter(filteringSources, (src) => {
          return src.c_u_PublishType == this.automaticPublish;
        });
      }
      if (this.automaticImport == 1) {
        filteringSources = _.filter(filteringSources, (src) => {
          return src.c_u_PublishType == this.automaticImport;
        });
      }

      this.filteredSources = filteringSources;
    },

    async openSection3(id) {
      this.isCreateSource = false;
      this.section3 = true;
      this.$api.data.endpoint = this.endpoint;
      this.clickedSource = await this.$api.data.findOneById(id);
    },

    async createSource() {
      if (
        (this.sourceObject.c_u_Status == -1 ||
          this.sourceObject.c_u_Status == 1) &&
        (this.sourceObject.c_u_Parameters1 == "" ||
          this.sourceObject.c_u_Parameters2 == "")
      ) {
        this.$bvToast.toast(
          "Para efetuar a criação da fonte é necessario preencher o XML1 e o XML2",
          {
            autoHideDelay: 4000,
            variant: "danger",
          }
        );
      } else {
        this.$api.data.endpoint = this.endpoint;
        this.sourceObject.c_u_Status = parseInt(this.sourceObject.c_u_Status);
        this.sourceObject.c_id = this.selectedSourceView.id;
        this.sourceObject.c_u_ReferenceSource = this.selectedSourceView.source;
        await this.$api.data.create(this.sourceObject);
        this.getSources();
        this.isCreateSource = false;
        this.sourceObject = {
          c_id: 0,
          c_u_Type: 0,
          c_u_Status: -1,
          c_u_PublishType: 0,
          c_u_Regularity: 0,
          c_u_ReferenceSource: "",
          c_u_Keywords: "",
          c_u_Parameters1: "",
          c_u_Parameters2: "",
        };
        this.selectedSourceView = [];
      }
    },
    //function to receive the data from modal XML1 and modal XML2
    createXmls(configs1, configs2) {
      this.sourceObject.c_u_Parameters1 = configs1;
      this.sourceObject.c_u_Parameters2 = configs2;
    },
    async editedSource() {
      this.clickedSource.c_u_Status = parseInt(this.clickedSource.c_u_Status);
      if (
        this.startDate != "" &&
        this.startHour != "" &&
        this.endDate != "" &&
        this.endHour != ""
      ) {
        this.timeSchedule.c_u_TimeStart = this.startDate + " " + this.startHour;
        this.timeSchedule.c_u_TimeEnd = this.endDate + " " + this.endHour;
        this.timeSchedule.c_r_Source = this.clickedSource.c_id;
        this.$api.data.endpoint = this.endpointTime;
        await this.$api.data.create(this.timeSchedule);
      }
      /*if (this.clickedSource.c_u_Parameters1 == "") {
        let source = await this.$api.data.findOneById(this.clickedSource.c_id);
        source.c_u_Parameters2 = this.clickedSource.c_u_Parameters2;
        this.$api.data.endpoint = this.endpoint;
        await this.$api.data.updatedById(this.clickedSource.c_id, source);
      } else {*/
      this.$api.data.endpoint = this.endpoint;
      await this.$api.data.updatedById(
        this.clickedSource.c_id,
        this.clickedSource
      );
      //}

      let updatedSources = await this.$api.data.find();
      this.filteredSources = updatedSources;
      this.sources = updatedSources;
      this.timeSchedule.c_u_TimeStart = "";
      this.timeSchedule.c_u_TimeEnd = "";
      this.timeSchedule.c_r_Source = 0;
      this.startHour = "";
      this.endHour = "";
      this.endDate = "";
      this.$forceUpdate();
    },

    deleteUrl(item) {
      this.sourceUrl = item.c_id;
    },
    // function to update the data from section1
    async deletedSource() {
      this.filteredSources = [];
      this.$api.data.endpoint = this.endpoint;
      let updatedSources = await this.$api.data.find();
      for (let index = 0; index < updatedSources.length; index++) {
        Vue.set(this.filteredSources, index, updatedSources[index]);
      }
      this.$forceUpdate();
      this.section3 = false;
    },

    editUrl(item) {
      console.log("item.c_u_Parameters1", item.c_u_Parameters1);
      console.log("item.c_u_Parameters2", item.c_u_Parameters2);
      this.idSource = item.c_id;
    },
    semicolonKey: function (event) {
      if (event.key != undefined) {
        if (event.keyCode == 32) {
          this.clickedSource.c_u_Keywords = `${this.clickedSource.c_u_Keywords.replace(
            /\s/g,
            ""
          )};`;
        }
      }
    },
    updateParamters(configs1, configs2) {
      if (configs1 == "") {
        configs1 = this.clickedSource.c_u_Parameters1;
      }
      if (configs2 == "") {
        configs2 = this.clickedSource.c_u_Parameters2;
      }

      this.clickedSource.c_u_Parameters1 = configs1;
      this.clickedSource.c_u_Parameters2 = configs2;
    },
  },

  mounted: function () {
    this.getSources();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mainWrapper {
  height: calc(100vh - 90px);
  overflow: hidden;
}

.sourceMain {
  overflow: hidden;
  /* height: 100vh; */
  height: 100%;
}

.sourceMainSections {
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
  height: 100%;
}

.section1Sources {
  display: block;
  max-height: 100%;
  height: 100%;
}

.sectionsFilters {
  margin-top: 10px;
  display: block;
  max-height: 100%;
  height: 100%;
}

.section1 {
  margin-top: 10px;
  background-color: rgb(242, 242, 242);
  /* height: 100%; */
  height: 89%;
}

.filters {
  background-color: rgb(66, 139, 172);
  color: white;
  font-weight: bold;
  text-align: center;
  padding: 10px;
  height: 50px;
}

.filtersTitle {
  float: left;
  color: rgb(66, 139, 172);
  font-weight: bold;
  font-size: 12px;
}

.filtersSelect {
  background-color: white;
}
.checkBox {
  margin-top: 5px;
}

.filtersCheckBox {
  color: rgb(66, 139, 172);
  font-weight: bold;
  font-size: 12px;
}

.filterButton {
  margin-top: 20px;
}
.btnFilter {
  background-color: rgb(66, 139, 172);
  color: white;
  font-weight: bold;
}

.section1Title {
  background-color: rgb(66, 139, 172);
  color: white;
  font-weight: bold;
  text-align: center;
  padding: 10px;
  height: 50px;
  margin-top: 10px;
}

.createDiv {
  text-align: right;
}

.createBtn {
  border-radius: 20px;
  background-color: rgb(231, 242, 245);
  color: rgb(66, 139, 172);
  padding: 0.275rem 0.55rem;
}

.section2 {
  background-color: rgb(242, 242, 242);
  overflow-y: scroll;
  /* height: 100%; */
  height: 90%;
}

.section2Source {
  border: 2px solid rgb(242, 242, 242);
  background-color: white;
  margin: 5px;
}

.section2Source:hover {
  box-shadow: 0 0 11px rgba(33, 33, 33, 0.2);
}
.section2Reference {
  color: rgb(66, 139, 172);
  font-weight: bold;
  font-size: 12px;
  text-align: left;
  margin: 5px;
}

.section3Reference {
  background-color: rgb(24, 65, 77);
  color: white;
  font-weight: bold;
  text-align: center;
  padding: 10px;
  height: 50px;
  margin-top: 10px;
}
.section3Title {
  background-color: rgb(66, 139, 172);
  color: white;
  font-weight: bold;
  text-align: left;
  border-radius: 10px;
  padding: 10px;
  height: 50px;
  margin-top: 10px;
}
.labelSource {
  background-color: rgb(66, 139, 172);
  color: white;
  font-weight: bold;
  text-align: left;
  border-radius: 10px;
  margin-top: 10px;
}

.referenceName {
  background-color: rgb(242, 242, 242);
  text-align: left;
  border-radius: 10px;
  margin-top: 10px;
}

.editXML button {
  background-color: rgb(66, 139, 172);
  color: white;
  margin-top: 10px;
  font-weight: bold;
}

.createXML button {
  background-color: rgb(66, 139, 172);
  color: white;
  margin-top: 10px;
  font-weight: bold;
}

.section3Footer button {
  background-color: rgb(77, 150, 132);
}
</style>



// WEBPACK FOOTER //
// src/components/Sources/SourceMain.vue